import { Box, styled } from "@mui/material";

export const AnimatedBox = styled(Box)({
  animation: "fadeIn 1s ease-in-out",
  "@keyframes fadeIn": {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 },
  },
});
